import axios from 'axios';

const APIRequest = () => {
  return axios.create({
    baseURL: 'https://api.screenshare.cool/api'
  });
}

export default APIRequest();
